import { commonCopySourceAdapts, CopySourceAdapter } from 'app/model/adapters/activities/copysource/copysource.adapter';
import { SapODataCopySource } from 'app/model/pipeline/copysource/sap-odata.copysource';
import { Model } from 'app/model/backendmodel';
import { AdapterRegistry, IModel, Metamodel } from 'shell-models-lib';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import { CopyActivity } from 'app/model/pipeline/copy.activity';
import { isArray } from 'lodash';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SapODataCopySource),
    asynchronous: true,
    adapts: {
        ...commonCopySourceAdapts,
        extractionMode: '*',
        deltaToken: '*',
        projection: '*',
        selection: '*',
        batchSize: '*',
        httpRequestTimeout: '*'
    }
})
export class SapODataCopySourceAdapter extends CopySourceAdapter<SapODataCopySource, Model.SapODataSource> {
    protected model(): IModel {
        return SapODataCopySource.MODEL;
    }

    protected override async _toResource(copySource: SapODataCopySource): Promise<Model.SapODataSource> {
        const result: Model.SapODataSource = this.getCommonCopySourceProperties(copySource, this.model().name);
        result.extractionMode = ValueAdapter.toResource(copySource, SapODataCopySource.EXTRACTION_MODE);
        result.deltaToken = ValueAdapter.toResource(copySource, SapODataCopySource.DELTA_TOKEN) || undefined;
        result.projection = ValueAdapter.toResource(copySource, SapODataCopySource.PROJECTION);
        result.selection = ValueAdapter.toResource(copySource, SapODataCopySource.SELECTION);
        result.batchSize = ValueAdapter.toResource(copySource, SapODataCopySource.BATCH_SIZE);
        result.httpRequestTimeout = ValueAdapter.toResource(copySource, SapODataCopySource.HTTP_REQUEST_TIMEOUT);
        if (isArray(result.projection) && !result.projection?.length) {
            Reflect.deleteProperty(result, 'projection');
        }
        if (isArray(result.selection) && !result.selection?.length) {
            Reflect.deleteProperty(result, 'selection');
        }
        return result;
    }

    protected override async _toModel(
        resource: Model.SapODataSource,
        copyActivity: CopyActivity
    ): Promise<SapODataCopySource> {
        const result = this.createCopySourceWithCommonProperties(
            this.model(),
            resource,
            copyActivity
        ) as SapODataCopySource;
        result.mode = 'table'; // only support table
        ValueAdapter.toModel(result, SapODataCopySource.EXTRACTION_MODE, resource.extractionMode);
        ValueAdapter.toModel(result, SapODataCopySource.DELTA_TOKEN, resource.deltaToken);
        ValueAdapter.toModel(result, SapODataCopySource.PROJECTION, resource.projection);
        ValueAdapter.toModel(result, SapODataCopySource.SELECTION, resource.selection);
        ValueAdapter.toModel(result, SapODataCopySource.BATCH_SIZE, resource.batchSize);
        ValueAdapter.toModel(result, SapODataCopySource.HTTP_REQUEST_TIMEOUT, resource.httpRequestTimeout);
        return result;
    }
}
